import { AuxiliaryPropertyEditorControl } from "../auxiliaryPropertyEditorControl";
import { ParameterInfo } from "./parameterInfo";
import { WindowAreaPropertyInfo } from "./window-area-property-info/windowAreaPropertyInfo";

export const createParameterInfo = (content: React.ReactNode): AuxiliaryPropertyEditorControl => {
    return {
        control: <ParameterInfo>{content}</ParameterInfo>,
        containerStyles,
        width,
    };
};

export const createWindowAreaParameterInfo = () => {
    return createParameterInfo(<WindowAreaPropertyInfo />);
};

const width = 26;
const containerStyles: React.CSSProperties = { marginTop: "auto", width };
